<template>
  <!--
      	作者：zhuchangtao
      	时间：2021-07-01
      	描述：活动列表 - 打卡规则
      -->
  <div >
    <div class="common-form">抽奖规则设置</div>



    <div >
      <el-form-item label="每次抽奖消耗积分">
        <div class="max-w460 d-s-c">
          <el-table :data="form.gradeList" border size="mini" style="width: 100%">
            <el-table-column prop="name" label="会员等级">
            </el-table-column>
            <el-table-column prop="name"  label="消耗积分">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.points" type="text" placeholder="请输入积分"></el-input>

                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

      <!--连续打卡额外奖励-->
      <div class="common-form active-basic">抽奖选项添加</div>
      <el-form-item label="">

        <div class="reward-list max-w460" >
          <div class="reward-item pr border" v-for="(item, reward_index) in form.sweepstakes_rules.reward_data" :key="reward_index">
            <el-button class="delete-reward" @click="deleteRewardClick(reward_index)" type="danger" size="small" icon="el-icon-close" circle></el-button>
            <el-form-item label="抽奖文案" >
              <div class="d-s-c">
                <div class="flex-1"><el-input v-model="item.title" placeholder="请输入抽奖文案" class="max-w460" type="text" ></el-input></div>

              </div>
            </el-form-item>
            <el-form-item label="中奖概率"  >
              <div class="d-s-c">
                <div class="flex-1"><el-input v-model="item.weight" placeholder="请输入中奖概率" class="max-w460" type="number" min="0"></el-input></div>

              </div>
              <div class="d-s-c">
                <div class="flex-1">中奖概率，数值越大中奖概率越高，数值一样时随机中奖</div>

              </div>
            </el-form-item>
            <el-form-item label="积分奖励">
              <div class="d-s-c">
                <div><el-checkbox v-model="item.is_point"></el-checkbox></div>
                <div v-if="item.is_point">
                  <el-form-item label="送" label-width="40px"  style="margin-bottom: 0;">
                    <div class="d-s-c">
                      <div class="flex-1"><el-input v-model="item.point" placeholder="请输入抽奖获得的积分" type="number" min="0"></el-input></div>
                      <span class="ml10 pr16">积分</span>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="礼品奖励">
              <div class="d-s-c">
                <div><el-checkbox v-model="item.is_product"></el-checkbox></div>
                <div v-if="item.is_product">
                  <el-form-item label="送" label-width="40px"  style="margin-bottom: 0;" >
                    <div class="d-s-c">
                      <div class="flex-1"><el-input v-model="item.product"  type="number" min="0"></el-input></div>
                      <el-button type="primary" @click="addRewardProduct(reward_index)">选择礼品</el-button>
                    </div>

                  </el-form-item>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="图片">
              <div class="d-s-c">
                <div><el-checkbox v-model="item.is_image"></el-checkbox></div>
                <div v-if="item.is_image">
                  <el-form-item label="" label-width="40px"   style="margin-bottom: 0;" >

                    <div class="d-c-c ad-picture" @click="openUpload(reward_index,30)">
                      <img v-if="item.image_id > 0" :src="item.file_path" width="30" height="30" />
                      <span v-else class="el-icon-picture-outline"></span>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
        <el-button size="small" icon="el-icon-plus"  @click="addReward">添加</el-button>
      </el-form-item>

    </div>
     <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--商品选择-->
    <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="false" :clockType='clockType' :index='index' @closeDialog="closeDialogFunc"></Product>
  </div>
</template>

<script>
  import Product from '@/components/product/Product.vue';
  import Upload from '@/components/file/Upload';
export default {
  components: {
    /*选择商品组件*/
    Product,
    Upload
  },
  data(){
    return {
      /*是否打开选择商品*/
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      /*打卡奖励类型*/
      clockType: false,
      index:null,
      isupload:false,

    };
  },
  props: ['form'],
  methods: {
    /*添加奖励*/
    addReward() {
      let obj = {
        title:'',
        weight:0,
        is_point: false,
        point: 0,
        is_product:false,
        product:0,
        is_image:false,
        image_id:0,
        file_path:'',
      };
      this.form.sweepstakes_rules.reward_data.push(obj);
    },

    /*删除奖励*/
    deleteRewardClick(e) {
      this.form.sweepstakes_rules.reward_data.splice(e, 1);
    },
    continuousclock(){

      this.form.sweepstakes_rules.reward_data=[];
    },
    
    /*关闭弹窗*/
    closeDialogFunc(e) {
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {

        this.form.sweepstakes_rules.reward_data[self.index].product = e.params.product_id;

      }
    },
    addRewardProduct(e){
      this.isproduct = true;
      this.index= e;
    },
   
    /*上传*/
    openUpload(e) {
      this.index= e;
      this.isupload = true;

    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {

          this.form.sweepstakes_rules.reward_data[this.index].image_id = e[0].file_id;
          this.form.sweepstakes_rules.reward_data[this.index].file_path = e[0].file_path;


      }
      this.isupload = false;
     }
  }
};
</script>

<style>
 .ad-picture {
    width: 30px;
    height: 30px;
    border-radius: 16px;
    font-size: 40px;
    border: 1px dashed #cccccc;
    color: $blue;
    cursor: pointer;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakes/part/Clock.vue